import { ArrowForward } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';

import { UserGroup } from '../../types';
import { Checkbox } from '../uiComponents/ComponentLibrary/Checkbox';

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    overflowY: 'auto',
    flex: 1,
  },
  listItem: {
    padding: 0,
  },
  listItemStartIcon: {
    minWidth: '0',
    marginRight: '10px',
  },
  listItemEndIcon: {
    minWidth: '0',
    marginRight: 'auto',
  },
  itemTitle: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
};

interface User {
  id: number;
  name: string;
  email: string;
}

interface GroupListProps {
  groups: UserGroup[];
  groupPreview?: UserGroup | null;
  onGroupSelect: (group: UserGroup) => void;
  onGroupPreviewSelect: (group: UserGroup) => void;
  selectedUsers: User[];
  hideCheckbox?: boolean;
}

export function GroupList({
  groups,
  groupPreview,
  onGroupSelect,
  onGroupPreviewSelect,
  selectedUsers,
  hideCheckbox,
}: GroupListProps) {
  const areAllUsersSelected = (group: UserGroup) =>
    group.users.every((groupUser) =>
      selectedUsers.some((selectedUser) => selectedUser.id === groupUser.mobile_user_id),
    );

  const getTotalAndSelectedUsers = (group: UserGroup) => {
    const totalUsers = group.users?.length || 0;
    const groupSelectedUsers = group.users?.filter((user) =>
      selectedUsers.some((selectedUser) => selectedUser.id === user.mobile_user_id),
    );
    return { total: totalUsers, selected: groupSelectedUsers?.length || 0 };
  };

  return (
    <Box sx={customStyles.container}>
      <List>
        {groups.map((group) => {
          if (group.users?.length === 0) return;
          const { total, selected } = getTotalAndSelectedUsers(group);
          return (
            <Box key={group.id}>
              <ListItem sx={customStyles.listItem}>
                {!hideCheckbox && (
                  <ListItemIcon sx={customStyles.listItemStartIcon}>
                    <Checkbox
                      checked={areAllUsersSelected(group)}
                      onChange={() => onGroupSelect(group)}
                    />
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={
                    <Typography sx={customStyles.itemTitle}>
                      {group.name}
                      <Chip
                        component='span'
                        label={`${selected}/${total}`}
                        size='small'
                      />
                    </Typography>
                  }
                  sx={{
                    color: groupPreview?.id === group.id ? '#3E8FFA' : 'inherit',
                  }}
                />
                <ListItemIcon sx={customStyles.listItemEndIcon}>
                  <IconButton onClick={() => onGroupPreviewSelect(group)}>
                    <ArrowForward
                      fontSize='medium'
                      sx={{
                        color: groupPreview?.id === group.id ? '#3E8FFA' : 'inherit',
                      }}
                    />
                  </IconButton>
                </ListItemIcon>
              </ListItem>
              <Divider />
            </Box>
          );
        })}
      </List>
    </Box>
  );
}
